import React from 'react';
import { MdOutlineToday } from "react-icons/md";
import { NavLink } from 'react-router-dom';
import { IoCalendarSharp } from "react-icons/io5";
import { IoTodaySharp } from "react-icons/io5";
import { FaUsers, FaCalendarAlt} from "react-icons/fa";
import { FaFaceSadCry } from "react-icons/fa6";

import './layout.css';

const AtdLayout = ({ children }) => {
  return (
    <div className='container-fluid'>
      <h1 className="layouts-title">
        <IoTodaySharp className="leave-policy-icon" />
      Today Attendance
      </h1>
      <hr />
      <section>
        <div className="nav-container">
          <ul className="nav-list">
            <li className="nav-item">
              <NavLink
                id="current-atd-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/current-atd"
              >
                <MdOutlineToday className="nav-icon" /> Current Date
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="Yesterday-attendence-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/yesterday-atd"
              >
                <IoCalendarSharp  className="nav-icon" /> Yesterday Attendance
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="view-atd-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/view-atd"
              >
                 <IoCalendarSharp  className="nav-icon" />  View Attendance by Date
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="approved-leave-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/all-emps"
              >
                <FaUsers className="nav-icon" /> All Employees
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="view-atd-day"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/view-atd-day"
              >
                <FaCalendarAlt className="nav-icon" /> View Atd By Day
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                id="view-atd-day"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/view-absents"
              >
                <FaFaceSadCry className="nav-icon" /> Abbsenties of the Day
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="content">
          {children} {/* Render the child components here */}
        </div>
      </section>
    </div>
  );
};

export default AtdLayout;